import hotkeys from 'hotkeys-js';
import { useCallback, useEffect } from 'react';

export default function useShortcut(keys, callback, deps) {
  const memoisedCallback = useCallback(callback, deps);

  useEffect(() => {
    hotkeys.filter = () => true;
    hotkeys(keys, memoisedCallback);

    return () => hotkeys.unbind(keys);
  }, [memoisedCallback]);
}
